import authorizationService from '@/core/auth/authorization-service'
import store from '@/store'
import _ from 'lodash'
import i18n from '@/core/localization/i18n'
import moment from 'moment'
import jwtDecode from 'jwt-decode'
import constants from '@/core/constants'

function getDefaultLocale() {
  const currentLanguage = store.getters.currentLanguage
  if(currentLanguage) {
    return currentLanguage
  }
  const claimIsoCode = authorizationService.getClaim(constants.customClaims.isoCode)
  const languages = store.getters.languages
  if(claimIsoCode) {
    return languages[claimIsoCode]
  }
  const claimCountry = authorizationService.getClaim(constants.customClaims.country)
  const matchingLocaleByCountry = getLanguageByCountry(claimCountry)

  return matchingLocaleByCountry || languages[getNavigatorLanguage()] || languages['en-US'] || languages[_.keys(languages)[0]]
}

function getLanguageByCountry(languages, country) {
  return _.find(languages, language => language.regionInfo.name === country)
}

function getCurrentUserCountry() {
  const claimCountry = authorizationService.getClaim(constants.customClaims.country)
  if(claimCountry) {
    return claimCountry
  }
  const claimAccessGroup = authorizationService.getClaim(constants.customClaims.accessGroup)
  if(_.isString(claimAccessGroup) && claimAccessGroup.length > 2) {
    return claimAccessGroup.substr(0, 2)
  }
}

function getCurrentIsoCode() {
  return _.get(store.getters, 'currentLanguage.isoCode')
}

function setLanguageByClaims(token) {
  const decodedToken = jwtDecode(token)
  const languages = store.getters.languages
  const localLanguageByIsoCode = languages[decodedToken.iso_code]
  if(localLanguageByIsoCode) {
    store.dispatch('setUserLanguage', localLanguageByIsoCode)
    return true
  }
  const languageByCountry = getLanguageByCountry(languages, decodedToken.country)
  const localLanguageByCountry = languageByCountry && languages[languageByCountry.isoCode]
  if(localLanguageByCountry) {
    store.dispatch('setUserLanguage', localLanguageByCountry)
    return true
  }
}

function getNavigatorLanguage() {
  if(navigator.languages && navigator.languages.length) {
    return navigator.languages[0]
  }
  return navigator.userLanguage || navigator.language || navigator.browserLanguage
}

function watchLanguageChange() {
  store.watch(state => state.user.currentLanguage, setLocale)
}

function setLocale(locale) {
  moment.locale(locale.isoCode)
  i18n.locale = locale.isoCode
}

function getCountryByCompany(company) {
  return _.get(company, 'accessGroup', '').substr(0, 2)
}

export default { getDefaultLocale, watchLanguageChange, setLocale, setLanguageByClaims, getCountryByCompany, getCurrentUserCountry, getCurrentIsoCode }
